import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { InputContainer, InputTag, ValidationError, Placeholder, TogglePasswordButton } from "./styles";

const EyeOpenIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EyeClosedIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

const Input = ({ htmlType, name, value, handleChange, disabled, handleBlur, placeholder, hasError, errors, floatingPlaceholder, id }) => {
  const [ isShown, togglePlaceholder ] = useState(true);
  const [ passwordVisible, setPasswordVisible ] = useState(false);

  const isPassword = htmlType === 'password';
  const inputType = isPassword && passwordVisible ? 'text' : htmlType;

  const haveValue = value && value.length;
  const inputClass = isShown && haveValue ? 'placeholder-shown' : ''

  return (
    <InputContainer className="input-container" hasError={hasError} disabled={disabled}>
      <InputTag
        className={inputClass}
        disabled={disabled}
        type={inputType}
        name={name}
        id={id}
        value={value}
        onChange={handleChange}
        onBlur={(...args) => { handleBlur(...args); togglePlaceholder(true) }}
        onFocus={() => togglePlaceholder(false)}
        placeholder={placeholder}
        floatingPlaceholder={floatingPlaceholder}
        hasToggle={isPassword}
      />
      {floatingPlaceholder && <Placeholder>{placeholder}</Placeholder>}
      {isPassword && (
        <TogglePasswordButton type="button" onClick={() => setPasswordVisible(!passwordVisible)} tabIndex={-1}>
          {passwordVisible ? <EyeOpenIcon /> : <EyeClosedIcon />}
        </TogglePasswordButton>
      )}
      {hasError && <ValidationError>{errors}</ValidationError>}
    </InputContainer>
  )
};

Input.propTypes = {
  htmlType: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  handleBlur: PropTypes.func,
  placeholder: PropTypes.string,
  hasError: PropTypes.bool,
  errors: PropTypes.string,
  floatingPlaceholder: PropTypes.bool,
  id: PropTypes.string,
};

export default Input;
